import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import FoundersMessage from '../components/FoundersMessage';
import CampusVision from '../components/CampusVision';
import Mascot from '../components/Mascot';
import TenYearPlan from '../components/TenYearPlan';
import EducatorLed from '../components/EducatorLed';
import CommunityApproach from '../components/CommunityApproach';
import Curriculum from '../components/Curriculum';
import WhyDoctrina from '../components/WhyDoctrina';
import Contact from '../components/Contact';
import { Petition } from '../components/Petition';
import Footer from '../components/Footer';

const Home = () => {
  const [activeTab, setActiveTab] = useState('home');

  return (
    <div className="min-h-screen bg-warmCream">
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <div className="pt-20">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          {/* Tab Navigation */}
          <div className="sticky top-20 z-40 bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
            <div className="container mx-auto px-4">
              <TabsList className="w-full grid grid-cols-5 lg:grid-cols-11 h-auto gap-1 bg-transparent p-2">
                <TabsTrigger value="home" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Home</TabsTrigger>
                <TabsTrigger value="mission" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Mission</TabsTrigger>
                <TabsTrigger value="founder" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Founder</TabsTrigger>
                <TabsTrigger value="campus" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Campus</TabsTrigger>
                <TabsTrigger value="mascot" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Mascot</TabsTrigger>
                <TabsTrigger value="plan" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">10-Year Plan</TabsTrigger>
                <TabsTrigger value="educators" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Educators</TabsTrigger>
                <TabsTrigger value="community" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Community</TabsTrigger>
                <TabsTrigger value="curriculum" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Curriculum</TabsTrigger>
                <TabsTrigger value="benefits" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Benefits</TabsTrigger>
                <TabsTrigger value="petition" className="data-[state=active]:bg-coralRed data-[state=active]:text-white text-sm py-3 font-bold">Support Us</TabsTrigger>
                <TabsTrigger value="contact" className="data-[state=active]:bg-tealAccent data-[state=active]:text-white text-sm py-3">Contact</TabsTrigger>
              </TabsList>
            </div>
          </div>

          {/* Tab Content */}
          <TabsContent value="home" className="mt-0">
            <Hero />
          </TabsContent>

          <TabsContent value="mission" className="mt-0">
            <Mission />
          </TabsContent>

          <TabsContent value="founder" className="mt-0">
            <FoundersMessage />
          </TabsContent>

          <TabsContent value="campus" className="mt-0">
            <CampusVision />
          </TabsContent>

          <TabsContent value="mascot" className="mt-0">
            <Mascot />
          </TabsContent>

          <TabsContent value="plan" className="mt-0">
            <TenYearPlan />
          </TabsContent>

          <TabsContent value="educators" className="mt-0">
            <EducatorLed />
          </TabsContent>

          <TabsContent value="community" className="mt-0">
            <CommunityApproach />
          </TabsContent>

          <TabsContent value="curriculum" className="mt-0">
            <Curriculum />
          </TabsContent>

          <TabsContent value="benefits" className="mt-0">
            <WhyDoctrina />
          </TabsContent>


          <TabsContent value="petition" className="mt-0">
            <Petition />
          </TabsContent>

          <TabsContent value="contact" className="mt-0">
            <Contact />
          </TabsContent>
        </Tabs>
      </div>

      <Footer activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
};

export default Home;